
var progressLess = {};
import genaration from '../../utils/classname';
export var progressClass = genaration(progressLess, 'progress');